import React, { useEffect, useState } from "react";

import axios from "axios";
import clsx from "clsx";

import { IconTickets } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

interface Props {
  image_url: string | null;
  archived?: boolean;
  className?: string;
}

export const TripItemImage: React.FC<Props> = ({
  image_url,
  archived = false,
  className
}) => {
  const { urlBuilder } = useAppContext();
  const [background_url, setBackgroundUrl] = useState<string | null>(
    image_url && urlBuilder.thumbnailHero(image_url, archived)
  );

  useEffect(() => {
    // Some hero urls are provided but are broken
    if (background_url) {
      axios.head(background_url).catch(() => {
        setBackgroundUrl(null);
      });
    }
  });

  return background_url ? (
    <div
      className={clsx(
        "flex h-800 w-800 shrink-0 items-center justify-center rounded-md bg-color-canvas-tertiary bg-cover bg-center",
        className
      )}
      style={{
        backgroundImage: `url(${background_url})`
      }}
    />
  ) : (
    <div
      className={clsx(
        "flex h-800 w-800 shrink-0 items-center justify-center rounded-md bg-color-canvas-tertiary",
        archived && "bg-color-canvas-secondary",
        className
      )}
    >
      <IconTickets
        size="lg"
        className={
          archived ? "text-icon-color-secondary" : "text-icon-color-primary"
        }
      />
    </div>
  );
};
